import { useSelector } from "react-redux"
import { Box, Grid, Stack, Typography } from "@mui/material"
import kedyAICat from "../../../assets/image/home/kedy-ai-cat.svg"
import aiSubtitles from "../../../assets/image/home/text-to-video.png"
import aiTTS from "../../../assets/image/home/tts.jfif"
import aiTranslation from "../../../assets/image/home/add-subtitle.png"
import aiGeneratedImages from "../../../assets/image/home/ai-image.jpg"


const OtherTools = () => {

    const languageStrs = useSelector((store) => store.editdata.languageStrs)

    return (
        <Stack alignItems={"center"} gap={1}>
            <Box display={"flex"} alignItems={"center"} gap={1} justifyContent={"center"}>
                <img width={"7%"} src={kedyAICat} />

                <Typography
                    variant="h3"
                    align="center"
                    sx={{
                        fontSize: { xs: '0.8rem', sm: '1.5rem', md: '2rem', lg: '3rem', xl: '3.5rem' },
                        fontWeight: 600,
                        marginBlock: '0.3rem',
                    }}
                >
                    {languageStrs.other_ai_tools}
                </Typography>

            </Box>

            <Grid container >
                <Grid item xs={12} sm={6} >
                    <Box
                        component={"img"}
                        src={aiSubtitles}
                        sx={{
                            width: "60%",
                            height: "60%",
                            objectFit: "cover",
                            borderRadius: 4
                        }}
                        marginInline="auto"

                    />
                    <Typography
                        align="center"

                        sx={{
                            fontSize: { xs: '0.8rem', sm: '1rem', md: '1.2rem', lg: '1.5rem', xl: '1.8rem' },
                        }}
                        marginTop={2}
                    >
                        {languageStrs.ai_generated_subtitles}
                    </Typography>
                </Grid>

                <Grid item xs={12} sm={6}>
                    <Box
                        component={"img"}
                        src={aiTranslation}
                        sx={{
                            width: "60%",
                            height: "60%",
                            objectFit: "cover",
                            borderRadius: 4
                        }}
                        marginInline="auto"
                    />

                    <Typography
                        align="center"
                        sx={{

                            fontSize: { xs: '0.8rem', sm: '1rem', md: '1.2rem', lg: '1.5rem', xl: '1.8rem' },
                        }}
                        marginTop={2}
                    >
                        {languageStrs.ai_translation}
                    </Typography>
                </Grid>


                <Grid item xs={12} sm={6}>
                    <Box
                        component={"img"}
                        src={aiTTS}
                        sx={{
                            width: "60%",
                            height: "35%",
                            objectFit: "cover",
                            borderRadius: 4
                        }}
                        marginInline="auto"
                    />

                    <Typography
                        align="center"
                        sx={{

                            fontSize: { xs: '0.8rem', sm: '1rem', md: '1.2rem', lg: '1.5rem', xl: '1.8rem' },
                        }}
                        marginTop={2}
                    >
                        {languageStrs.ai_text_to_speech}
                    </Typography>
                </Grid>

                <Grid item xs={12} sm={6}>
                    <Box
                        component={"img"}
                        src={aiGeneratedImages}
                        sx={{
                            width: "60%",
                            height: "35%",
                            objectFit: "cover",
                            borderRadius: 4
                        }}
                        marginInline="auto"
                    />

                    <Typography
                        align="center"
                        sx={{
                            fontSize: { xs: '0.8rem', sm: '1rem', md: '1.2rem', lg: '1.5rem', xl: '1.8rem' },
                        }}
                        marginTop={2}
                    >
                        {languageStrs.ai_generated_images}
                    </Typography>
                </Grid>
            </Grid>
        </Stack>
    )
}

export default OtherTools